import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedUser: null,
  isGroup: false,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload
    },
    setIsGroup: (state, action) => {
      state.isGroup = action.payload
    },
  },
})

export const { setSelectedUser, setIsGroup } = userSlice.actions

export default userSlice.reducer
